module.exports = __webpack_public_path__ + "img/browser-safari-logo.401fd1a0.webp";